import { getIntegrationMarketplaceDetails } from '@/pages/api/community/publicCommunityApi';
import { type IntegrationsMarketplaceEHRSimpleResponse } from '@/types/global-types';
import { type EHRProvider } from '@heidi/schema/ml-scribe';
import { skipToken, useQuery } from '@tanstack/react-query';

const INTEGRATION_MARKETPLACE_DETAILS = '/integration-marketplace/integrations';

type Props = {
  ehrProvider?: EHRProvider | null;
  useSimpleResponse?: boolean;
  language?: string;
};

export const useQueryIntegrationMarketplaceDetailsByEHRProvider = <
  T = IntegrationsMarketplaceEHRSimpleResponse,
>(
  { ehrProvider, useSimpleResponse, language }: Props,
  {
    select,
  }: {
    select?: (data: IntegrationsMarketplaceEHRSimpleResponse) => T;
  } = {}
) => {
  return useQuery({
    queryKey: [
      INTEGRATION_MARKETPLACE_DETAILS,
      { ehrProvider, useSimpleResponse, language },
    ],
    queryFn: ehrProvider
      ? async () => {
          const { data } = await getIntegrationMarketplaceDetails({
            ehr_provider: ehrProvider,
            use_simple_response: useSimpleResponse,
            language,
          });
          return data;
        }
      : skipToken,
    select,
  });
};
